/* eslint-disable @typescript-eslint/no-empty-function */
module.exports = {
  i18n: {
    defaultLocale: 'ko',
    locales: ['ko', 'en'],
  },
  use: [
    {
      type: 'backend',
      read: () => {},
    },
  ],
};
